module.exports = __webpack_public_path__ + "static/media/Asset 38.cad0dc44.png";